"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { SubstitutionData } from "./playerEventsHelper";
import { SubstitutionRow } from "./SubstitutionRow";
import { getLabel } from "@/lib/labels/getLabel";
import type { Labels } from "@/lib/labels/types";
interface SubstitutionsSectionProps {
  homeSubstitutions: SubstitutionData[];
  awaySubstitutions: SubstitutionData[];
  labels: Labels;
  /** For mobile single team mode - only show one team's substitutions */
  activeTeam?: "home" | "away";
}

/**
 * SubstitutionsSection - Displays substitutions for both teams side by side
 * Shows player out/in pairs with minute for each substitution
 */
export const SubstitutionsSection: React.FC<SubstitutionsSectionProps> = t0 => {
  const $ = _c(36);
  const {
    homeSubstitutions,
    awaySubstitutions,
    labels,
    activeTeam
  } = t0;
  if (homeSubstitutions.length === 0 && awaySubstitutions.length === 0) {
    return null;
  }
  if (activeTeam) {
    const substitutions = activeTeam === "home" ? homeSubstitutions : awaySubstitutions;
    if (substitutions.length === 0) {
      return null;
    }
    let t1;
    if ($[0] !== labels) {
      t1 = getLabel(labels, "matchPage.lineups.substitutions");
      $[0] = labels;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    if ($[2] !== t1) {
      t2 = <div className="text-xs font-bold text-muted-foreground uppercase mb-2">{t1}</div>;
      $[2] = t1;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== substitutions) {
      t3 = substitutions.map(_temp);
      $[4] = substitutions;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== t3) {
      t4 = <div>{t3}</div>;
      $[6] = t3;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t2 || $[9] !== t4) {
      t5 = <div className="px-3 py-2 border-t border-border">{t2}{t4}</div>;
      $[8] = t2;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  let t1;
  if ($[11] !== labels) {
    t1 = getLabel(labels, "matchPage.lineups.substitutions");
    $[11] = labels;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== t1) {
    t2 = <div className="px-3 pt-3 pb-1"><span className="text-xs font-bold text-muted-foreground uppercase">{t1}</span></div>;
    $[13] = t1;
    $[14] = t2;
  } else {
    t2 = $[14];
  }
  let t3;
  if ($[15] !== labels) {
    t3 = getLabel(labels, "matchPage.lineups.substitutions");
    $[15] = labels;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== t3) {
    t4 = <div className="px-3 pt-3 pb-1 text-right"><span className="text-xs font-bold text-muted-foreground uppercase">{t3}</span></div>;
    $[17] = t3;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== t2 || $[20] !== t4) {
    t5 = <div className="grid grid-cols-2 divide-x divide-border">{t2}{t4}</div>;
    $[19] = t2;
    $[20] = t4;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  if ($[22] !== homeSubstitutions) {
    t6 = homeSubstitutions.length > 0 ? homeSubstitutions.map(_temp2) : <div className="text-xs text-muted-foreground py-2">-</div>;
    $[22] = homeSubstitutions;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t6) {
    t7 = <div className="px-3 pb-3">{t6}</div>;
    $[24] = t6;
    $[25] = t7;
  } else {
    t7 = $[25];
  }
  let t8;
  if ($[26] !== awaySubstitutions) {
    t8 = awaySubstitutions.length > 0 ? awaySubstitutions.map(_temp3) : <div className="text-xs text-muted-foreground py-2 text-right">-</div>;
    $[26] = awaySubstitutions;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== t8) {
    t9 = <div className="px-3 pb-3">{t8}</div>;
    $[28] = t8;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== t7 || $[31] !== t9) {
    t10 = <div className="grid grid-cols-2 divide-x divide-border">{t7}{t9}</div>;
    $[30] = t7;
    $[31] = t9;
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== t10 || $[34] !== t5) {
    t11 = <div className="border-t border-border">{t5}{t10}</div>;
    $[33] = t10;
    $[34] = t5;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  return t11;
};
function _temp(sub, idx) {
  return <SubstitutionRow key={idx} substitution={sub} alignLeft={true} />;
}
function _temp2(sub_0, idx_0) {
  return <SubstitutionRow key={idx_0} substitution={sub_0} alignLeft={true} />;
}
function _temp3(sub_1, idx_1) {
  return <SubstitutionRow key={idx_1} substitution={sub_1} alignLeft={false} />;
}